<template>
  <div class="max-w-[800px] flex gap-1">
    <CDropdown
      :on-clickoutside="
        () => {
          selectedOverrideOptions = 'default'
        }
      "
      :options="[
        {
          label: t('canvasUI.CRichTextEditor.CEditorMenu.CTableToolbar.toggleHeaderColumn'),
          action: () => {
            selectedOverrideOptions = 'default'
            editor.chain().focus().toggleHeaderColumn().run()
          },
          disabled: !editor.can().toggleHeaderColumn(),
          icon: () => h(CIcon, { icon: 'columns' }),
        },
        {
          label: t('canvasUI.CRichTextEditor.CEditorMenu.CTableToolbar.toggleHeaderRow'),
          action: () => {
            selectedOverrideOptions = 'default'
            editor.chain().focus().toggleHeaderRow().run()
          },
          disabled: !editor.can().toggleHeaderRow(),
          icon: () => h(CIcon, { icon: 'align-justify' }),
        },
        {
          label: t('canvasUI.CRichTextEditor.CEditorMenu.CTableToolbar.toggleHeaderCell'),
          action: () => {
            selectedOverrideOptions = 'default'
            editor.chain().focus().toggleHeaderCell().run()
          },
          disabled: !editor.can().toggleHeaderCell(),
          icon: () => h(CIcon, { icon: 'table' }),
        },
        {
          label: t('canvasUI.CRichTextEditor.CEditorMenu.CTableToolbar.highlightCell'),
          action: () => {
            selectedOverrideOptions = 'default'
            editor.chain().focus().setCellAttribute('backgroundColor', themeVars.info3).run()
          },
          disabled: !editor.can().setCellAttribute('backgroundColor', themeVars.info3),
          icon: () => h(CIcon, { icon: 'highlighter' }),
        },
        {
          label: t('canvasUI.CRichTextEditor.CEditorMenu.CTableToolbar.removeCellHighlight'),
          action: () => {
            selectedOverrideOptions = 'default'
            editor.chain().focus().setCellAttribute('backgroundColor', null).run()
          },
          disabled: !editor.can().setCellAttribute('backgroundColor', null),
          icon: () => h(CIcon, { icon: 'highlighter-line' }),
        },
        {
          label: t('canvasUI.CRichTextEditor.CEditorMenu.CTableToolbar.mergeCells'),
          action: () => {
            selectedOverrideOptions = 'default'
            editor.chain().focus().mergeCells().run()
          },
          disabled: !editor.can().mergeCells(),
          icon: () => h(CIcon, { icon: 'compress-arrows-alt' }),
        },
        {
          label: t('canvasUI.CRichTextEditor.CEditorMenu.CTableToolbar.splitCell'),
          action: () => {
            selectedOverrideOptions = 'default'
            editor.chain().focus().splitCell().run()
          },
          disabled: !editor.can().splitCell(),
          icon: () => h(CIcon, { icon: 'expand-arrows-alt' }),
        },
      ]"
      placement="bottom-start"
      :themeOverrides="themeOverrides"
      trigger="click"
      @select="(_, { action }: any) => action()"
    >
      <CButton :themeOverrides="themeOverrides[selectedOverrideOptions]" @click="selectedOverrideOptions = 'active'">
        {{ t('canvasUI.CRichTextEditor.CEditorMenu.CTableToolbar.tableOptions') }}
        <CIcon class="ml-1" faType="fa" icon="chevron-down" :size="12" />
      </CButton>
    </CDropdown>
    <CDropdown
      :on-clickoutside="
        () => {
          selectedOverrideAdd = 'default'
        }
      "
      :options="[
        {
          label: t('canvasUI.CRichTextEditor.CEditorMenu.CTableToolbar.addRowBefore'),
          action: () => {
            selectedOverrideAdd = 'default'
            editor.chain().focus().addRowBefore().run()
          },
          disabled: !editor.can().addRowBefore(),
          icon: () => h(CIcon, { icon: 'align-justify' }),
        },
        {
          label: t('canvasUI.CRichTextEditor.CEditorMenu.CTableToolbar.addRowAfter'),
          action: () => {
            selectedOverrideAdd = 'default'
            editor.chain().focus().addRowAfter().run()
          },
          disabled: !editor.can().addRowAfter(),
          icon: () => h(CIcon, { icon: 'align-justify' }),
        },
        {
          label: t('canvasUI.CRichTextEditor.CEditorMenu.CTableToolbar.addColumnBefore'),
          action: () => {
            selectedOverrideAdd = 'default'
            editor.chain().focus().addColumnBefore().run()
          },
          disabled: !editor.can().addColumnBefore(),
          icon: () => h(CIcon, { icon: 'columns' }),
        },
        {
          label: t('canvasUI.CRichTextEditor.CEditorMenu.CTableToolbar.addColumnAfter'),
          action: () => {
            selectedOverrideAdd = 'default'
            editor.chain().focus().addColumnAfter().run()
          },
          disabled: !editor.can().addColumnAfter(),
          icon: () => h(CIcon, { icon: 'columns' }),
        },
      ]"
      placement="bottom-start"
      trigger="click"
      @select="(_, { action }: any) => action()"
    >
      <CButton :themeOverrides="themeOverrides[selectedOverrideAdd]" @click="selectedOverrideAdd = 'active'">
        {{ t('canvasUI.CRichTextEditor.CEditorMenu.CTableToolbar.add') }}
        <CIcon class="ml-1" faType="fa" icon="chevron-down" :size="12" />
      </CButton>
    </CDropdown>
    <CDropdown
      :on-clickoutside="
        () => {
          selectedOverrideDelete = 'default'
        }
      "
      :options="[
        {
          label: t('canvasUI.CRichTextEditor.CEditorMenu.CTableToolbar.deleteColumn'),
          action: () => {
            selectedOverrideDelete = 'default'
            editor.chain().focus().deleteColumn().run()
          },
          disabled: !editor.can().deleteColumn(),
          icon: () => h(CIcon, { icon: 'columns' }),
        },
        {
          label: t('canvasUI.CRichTextEditor.CEditorMenu.CTableToolbar.deleteRow'),
          action: () => {
            selectedOverrideDelete = 'default'
            editor.chain().focus().deleteRow().run()
          },
          disabled: !editor.can().deleteRow(),
          icon: () => h(CIcon, { icon: 'align-justify' }),
        },
        {
          label: t('canvasUI.CRichTextEditor.CEditorMenu.CTableToolbar.deleteTable'),
          action: () => {
            selectedOverrideDelete = 'default'
            editor.chain().focus().deleteTable().run()
          },
          disabled: !editor.can().deleteTable(),
          icon: () => h(CIcon, { icon: 'table' }),
        },
      ]"
      placement="bottom-start"
      trigger="click"
      @select="(_, { action }: any) => action()"
    >
      <CButton :themeOverrides="themeOverrides[selectedOverrideDelete]" @click="selectedOverrideDelete = 'active'">
        {{ t('canvasUI.CRichTextEditor.CEditorMenu.CTableToolbar.delete') }}
        <CIcon class="ml-1" faType="fa" icon="chevron-down" :size="12" />
      </CButton>
    </CDropdown>
  </div>
</template>

<script setup lang="ts">
import { type StyleValue, h, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import type { Editor } from '@tiptap/vue-3'

import CIcon from '@lib/components/CIcon/CIcon.vue'
import CButton from '@lib/components/CButton/CButton.vue'
import CDropdown from '@lib/components/CDropdown/CDropdown.vue'
import useThemeVars from '@lib/composables/useThemeVars'

defineProps<{
  editor: Editor
  themeOverrides: { active: StyleValue; default: StyleValue }
}>()

const { t } = useI18n()
const themeVars = useThemeVars()

const selectedOverrideAdd = ref<'default' | 'active'>('default')
const selectedOverrideDelete = ref<'default' | 'active'>('default')
const selectedOverrideOptions = ref<'default' | 'active'>('default')
</script>
